<p class="source" *ngIf="copy && !url">
    {{prefix}}<br/>{{copy}}
</p>
<p class="source" *ngIf="copy && url">
    {{prefix}}<br/><a [href]="url" target="_blank">{{copy}}</a>
</p>
